import Button from "../../../../../../../../components/Button/Button";
import RightArrowIcon from "../../../../../../../../assets/svg/right-arrow-icon";
import ManageDocumentsTable from "../ManageDocumentsTable/ManageDocumentsTable";
import { KnowledgeBaseCategory } from "../../utils/types";
import { SystemName } from "../../utils/categoryIcons";
import AddIcon from "../../../../../../../../assets/svg/add-icon";
import { useState } from "react";
import AddContentDrawer from "../AddContentDrawer/AddContentDrawer";

interface CategoryDetailViewProps {
  topic: KnowledgeBaseCategory;
  onGoBack: () => void;
}

const CategoryDetailView = ({ topic, onGoBack }: CategoryDetailViewProps) => {
  const systemName = topic?.id as SystemName;
  const [isAddContentDrawerOpen, setIsAddContentDrawerOpen] = useState(false);

  const renderIcon = () => {
    if (typeof topic?.icon === "string") {
      return (
        <img
          src={topic?.icon}
          alt={topic?.title}
          className={topic?.iconClassName}
        />
      );
    }
    const IconComponent = topic?.icon;
    return <IconComponent className={topic?.iconClassName} />;
  };

  return (
    <div className="flex flex-col gap-[28px] p-4">
      <div className="flex items-center gap-3.5">
        <Button
          innerText="Go Back"
          iconLeft={true}
          Icon={RightArrowIcon}
          buttonContainerClass="w-fit"
          innerTextClass="text-md font-medium text-verba-indigo dark:text-verba-indigo-dk leading-normal"
          iconClass="w-4.5 h-4.5 text-verba-indigo dark:text-verba-indigo-dk rotate-180"
          onClick={onGoBack}
        />
        <div className="h-4 w-px bg-border-gray dark:bg-border-gray-dk" />
        <Button
          Icon={AddIcon}
          iconLeft={true}
          iconClass="w-4 h-4 text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk"
          innerText="Upload Document"
          onClick={() => setIsAddContentDrawerOpen(true)}
          buttonContainerClass="hover:bg-verba-blue-hover dark:hover:bg-verba-blue-hover-dk border border-verba-blue dark:border-verba-blue-dk bg-verba-blue dark:bg-verba-blue-dk w-fit font-semibold py-1.5 px-4 rounded-lg"
          innerTextClass="text-fixed-white-light-and-dark-mode dark:text-fixed-white-light-and-dark-mode-dk text-md font-semibold text-nowrap"
        />
      </div>

      <div className="flex items-center gap-3">
        <div className="shrink-0">{renderIcon()}</div>
        <div className="flex flex-col gap-1">
          <p className="text-base font-medium text-heading-text dark:text-heading-text-dk leading-none">
            {topic?.title}
          </p>
          <p className="text-md font-normal text-dark-gray dark:text-dark-gray-dk leading-normal">
            {topic?.description}
          </p>
        </div>
      </div>

      <ManageDocumentsTable
        title={`${topic?.title} Documents`}
        systemNameFilter={systemName}
        categoryFilter={topic?.id}
      />
      <AddContentDrawer
        open={isAddContentDrawerOpen}
        onClose={() => setIsAddContentDrawerOpen(false)}
        categories={[
          {
            id: topic?.id,
            title: topic?.title,
            icon: topic?.icon,
            iconClassName: topic?.iconClassName,
          },
        ]}
        defaultCategoryId={topic?.id}
        disableCategorySelection
      />
    </div>
  );
};

export default CategoryDetailView;
